document.addEventListener('DOMContentLoaded', async function () {
    let estimate_body = document.querySelector('body.estimate-edit');
    if (!estimate_body) {
        return;
    }

    //global vars
    //const BUILDING_COLORS = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEEAD', '#D4A5A5', '#9B786F', '#E6E6FA'];
    const facetMap = {}; // Initialize facetMap at the top level
    let calculatorState_value = document.getElementById('calculator_state').value;
    let json = atob(calculatorState_value);
    const calculatorState = JSON.parse(json);
    console.log('calculatorState', calculatorState);

    let leadJson_value = document.getElementById('lead_json').value;
    json = atob(leadJson_value);
    const outputJson = JSON.parse(json);
    console.log('start outputJson', outputJson);

    //new outputJson
    let buildingsHeights = await updateBuildingsHeights(wdsCalculatorData, calculatorState);
    let newoutputJson = buildNewOutputJson(outputJson, calculatorState, buildingsHeights);
    console.log('newoutputJson', newoutputJson);

    // Sync corrected RoofType from newoutputJson back into outputJson and DOM
    if (newoutputJson.Buildings && outputJson.Buildings) {
        newoutputJson.Buildings.forEach((newBldg, i) => {
            const oldType = outputJson.Buildings[i]?.RoofType || outputJson.Buildings[i]?.Roof?.Type;
            const newType = newBldg.Roof?.Type;
            if (oldType && newType && oldType !== newType) {
                if (outputJson.Buildings[i].Roof) outputJson.Buildings[i].Roof.Type = newType;
                outputJson.Buildings[i].RoofType = newType;
                const buildingId = newBldg.ID || outputJson.Buildings[i].ID;
                // Update building card label
                document.querySelectorAll(`.building-${buildingId} .roof_type_text`).forEach(el => {
                    el.textContent = newType;
                });
                // Update popup selected value and dropdown selection
                const popup = document.querySelector(`.estimate-edit__popups-building-${buildingId}`);
                if (popup) {
                    const valueSpan = popup.querySelector('.estimate-edit__popups-building-type .value');
                    if (valueSpan) valueSpan.textContent = newType;
                    popup.querySelectorAll('.estimate-edit__popups-building-type .estimate-edit__popups-building-select-item').forEach(item => {
                        const selectValue = item.querySelector('.select-value')?.textContent?.trim();
                        if (selectValue === newType) {
                            item.classList.add('selected');
                            const icon = item.querySelector('.estimate-edit__popups-building-select-item-icon img');
                            const popupIcon = popup.querySelector('.estimate-edit__popups-building-type .estimate-edit__popups-building-value-icon img');
                            if (icon && popupIcon) popupIcon.src = icon.src;
                        } else {
                            item.classList.remove('selected');
                        }
                    });
                }
            }
        });
    }

    let mapInstance = null;

    // Building colors
    const BUILDING_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

    //global vars

    //check get variable send_to_crm in url
    let send_to_crm = new URLSearchParams(window.location.search).get('send_to_crm');
    if (send_to_crm) {
        showGlobalLoader();
        updateJsonData();
        saveLead();
        sendToCRM();
    }

    //add blocks
    //add overlay after open body
    let overlay = document.createElement('div');
    overlay.classList.add('estimate-edit__overlay');
    estimate_body.appendChild(overlay);
    //add help button to header__content
    let header_content = document.querySelector('.header__content');
    let help_btn = document.createElement('div');
    help_btn.classList.add('estimate-edit__help-btn', 'flex', 'justify-center', 'items-center');
    help_btn.innerHTML = `<span class="icon icon-help"></span><span>${wdsCalculatorData['estimateEdit']['header']['help_label']}</span>`;
    header_content.appendChild(help_btn);
    header_content.classList.add('wds-roof-calculator');
    //add blocks


    //popups
    if (help_btn) {
        help_btn.addEventListener('click', function (e) {
            let popup = document.querySelector('.estimate-edit__popups-help');
            popup.classList.add('active');
            overlay.classList.add('active');
            estimate_body.classList.add('no-scroll');
            //console.log(estimate_body.classList);
        });
    }

    let enova_popup_btn = document.querySelectorAll('.enova-popup-btn');
    if (enova_popup_btn.length) {
        enova_popup_btn.forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                let popup = document.querySelector('.estimate-edit__popups-enova');
                popup.classList.add('active');
                overlay.classList.add('active');
                estimate_body.classList.add('no-scroll');
            });
        });
    }

    //details popups
    updateMaterialDescription();
    let details_btns = document.querySelectorAll('.estimate-edit__change-buildings-buildings__item-edit_btn');
    if (details_btns.length) {
        details_btns.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let dataPopup = btn.dataset.popup;
                let detailsPopup = document.querySelector('.estimate-edit__popups-' + dataPopup);
                detailsPopup.classList.add('active');
                overlay.classList.add('active');
                estimate_body.classList.add('no-scroll');
            });
        });
    }

    updateOddClassesServiceItems();
    document.addEventListener('click', e => {
        let popup = document.querySelector('.estimate-edit__popup.active');
        if (!popup) {
            return;
        }
        //get buildingId from class
        let buildingClass = Array.from(popup.classList).find(cls => cls.startsWith('estimate-edit__popups-building-'));
        let buildingId = buildingClass.replace('estimate-edit__popups-building-', '');

        //dropdowns
        const value = e.target.closest('.estimate-edit__popups-building-value.value-btn');
        let all_selects = popup.querySelectorAll('.estimate-edit__popups-building-select.active');
        if (value) {
            let parent = e.target.closest('.estimate-edit__popups-building-select-container');
            let select = parent.querySelector('.estimate-edit__popups-building-select');

            all_selects.forEach(container => {
                if (container !== select) {
                    container.classList.remove('active');
                }
            });

            select.classList.toggle('active');
        } else {
            all_selects.forEach(container => {
                container.classList.remove('active');
            });
        }

        const selectItem = e.target.closest('.estimate-edit__popups-building-select-item');
        if (selectItem) {
            let parent = e.target.closest('.estimate-edit__popups-building-select-container');
            let select = parent.querySelector('.estimate-edit__popups-building-select');
            select.classList.remove('active');
            parent.querySelector('.value-btn .value').textContent = selectItem.querySelector('.select-value').textContent;

            parent.querySelectorAll('.estimate-edit__popups-building-select-item').forEach(item => item.classList.remove('selected'));
            selectItem.classList.add('selected');

            //roof age
            if (parent.classList.contains('estimate-edit__popups-building-age')) {
                let show_enova = selectItem.dataset.show_enova;
                let age_value = selectItem.dataset.value.trim();
                parent.querySelector('.value-btn .value').dataset.value = age_value;
                updateEnovaCalculations(buildingId);
                if (show_enova === 'true') {
                    popup.querySelector('.estimate-edit__popups-building-additional-service').classList.remove('hidden');
                    popup.querySelector('.estimate-edit__services-item-renew').classList.add('excluded');
                } else {
                    popup.querySelector('.estimate-edit__popups-building-additional-service').classList.add('hidden');
                    popup.querySelector('.estimate-edit__services-item-renew').classList.remove('excluded');
                }
                //check and switch active buildings to other service
                let active_service = document.querySelector('.estimate-edit__services-item.excluded');
                if (active_service) {
                    active_service.classList.remove('active');
                    let replace_service = document.querySelector('.estimate-edit__services-item-replace');
                    replace_service.classList.add('active');
                }
                updateOddClassesServiceItems();
                updateServicePrices(popup, selectItem, buildingId);
            }
            //roof type
            if (parent.classList.contains('estimate-edit__popups-building-type')) {
                let clone = selectItem.querySelector('.estimate-edit__popups-building-select-item-icon img').cloneNode(true);
                popup.querySelector('.estimate-edit__popups-building-type .estimate-edit__popups-building-value-icon').innerHTML = '';
                popup.querySelector('.estimate-edit__popups-building-type .estimate-edit__popups-building-value-icon').appendChild(clone);
            }
            //material
            if (parent.classList.contains('estimate-edit__popups-building-material')) {
                //update material icon
                let clone = selectItem.querySelector('.estimate-edit__popups-building-select-item-icon img').cloneNode(true);
                popup.querySelector('.estimate-edit__popups-building-material .estimate-edit__popups-building-value-icon').innerHTML = '';
                popup.querySelector('.estimate-edit__popups-building-material .estimate-edit__popups-building-value-icon').appendChild(clone);

                //check takforming and cleaning for selected material
                let show_takfornying = selectItem.dataset.show_takfornying;
                let show_cleaning = selectItem.dataset.show_cleaning;
                if (show_takfornying === 'true') {
                    popup.querySelector('.estimate-edit__services-item-renew').classList.remove('excluded');
                } else {
                    popup.querySelector('.estimate-edit__services-item-renew').classList.add('excluded');
                }
                if (show_cleaning === 'true') {
                    popup.querySelector('.estimate-edit__services-item-cleaning').classList.remove('excluded');
                } else {
                    popup.querySelector('.estimate-edit__services-item-cleaning').classList.add('excluded');
                }
                //check and switch active buildings to other service
                let active_service = document.querySelector('.estimate-edit__services-item.excluded');
                if (active_service) {
                    active_service.classList.remove('active');
                    let replace_service = document.querySelector('.estimate-edit__services-item-replace');
                    replace_service.classList.add('active');
                }
                updateOddClassesServiceItems();

                /*
                //update service prices
                let replace_price = selectItem.dataset.replace;
                popup.querySelector('.estimate-edit__services-item-replace .price_value').dataset.value = replace_price;
                let rehab_price = selectItem.dataset.rehab;
                popup.querySelector('.estimate-edit__services-item-rehab .price_value').dataset.value = rehab_price;

                let formatted_replace = new Intl.NumberFormat('fr-FR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(replace_price);
                let formatted_rehab = new Intl.NumberFormat('fr-FR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(rehab_price);
                popup.querySelector('.estimate-edit__services-item-replace .price_value').textContent = formatted_replace;
                popup.querySelector('.estimate-edit__services-item-rehab .price_value').textContent = formatted_rehab;

                 */
                updateServicePrices(popup, selectItem, buildingId);
            }
        }
        //services
        let service_item = e.target.closest('.estimate-edit__services-item');
        if (service_item) {
            let services = e.target.closest('.estimate-edit__services-items');
            services.querySelectorAll('.estimate-edit__services-item').forEach(item => item.classList.remove('active'));
            service_item.classList.add('active');
            let show_enova = popup.querySelector('.estimate-edit__popups-building-age .estimate-edit__popups-building-select-item.selected').dataset.show_enova;
            let additional_service = popup.querySelector('.estimate-edit__additional-services');
            if (service_item.classList.contains('hide-additional') || show_enova === 'false') {
                additional_service.classList.add('hidden');
            } else {
                additional_service.classList.remove('hidden');
            }
            UpdatePopupDetailsTotals(buildingId);
        }
        //enova
        let enova_btn = e.target.closest('.estimate-edit__additional-services-active-btn');
        if (enova_btn) {
            let parent = e.target.closest('.estimate-edit__additional-services');
            parent.classList.toggle('active');
            UpdatePopupDetailsTotals(buildingId);
        }
        //enova

    }, true);

    let popupButtonsCancel = document.querySelectorAll('.estimate-edit__popups-building-button--cancel');
    if (popupButtonsCancel.length) {
        popupButtonsCancel.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let popup = document.querySelector('.estimate-edit__popup.active');
                popup.classList.remove('active');
                overlay.classList.remove('active');
                estimate_body.classList.remove('no-scroll');
            });
        });
    }

    let popupButtonsSave = document.querySelectorAll('.estimate-edit__popups-building-button--save');
    if (popupButtonsSave.length) {
        popupButtonsSave.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let popup = document.querySelector('.estimate-edit__popup.active');
                popup.classList.remove('active');
                overlay.classList.remove('active');
                estimate_body.classList.remove('no-scroll');

                let buildingClass = Array.from(popup.classList).find(cls => cls.startsWith('estimate-edit__popups-building-'));
                let buildingId = buildingClass.replace('estimate-edit__popups-building-', '');
                let buildingItem = document.querySelector('.estimate-edit__change-buildings .estimate-edit__change-buildings-buildings__item.building-' + buildingId);

                let building_type = popup.querySelector('.estimate-edit__popups-building-type .estimate-edit__popups-building-select-item.selected .select-value').textContent.trim();
                let roof_material_text = popup.querySelector('.estimate-edit__popups-building-material .estimate-edit__popups-building-select-item.selected .select-value').textContent.trim();
                let building_price = popup.querySelector('.estimate-edit__popups-building-price .building_price_value').dataset.value;
                let formatted_building_price = formatWithVisualSpaces(building_price);

                let globalBuildingItems = document.querySelectorAll('.building-' + buildingId + ':not(.estimate-edit__change-buildings-mobile-nav__item)');
                if (globalBuildingItems.length) {
                    globalBuildingItems.forEach(item => {
                        console.log(item);
                        const roofTypeEl = item.querySelector('.roof_type_text');
                        const materialEl = item.querySelector('.material_text');
                        const priceEl = item.querySelector('.building_price_value');
                        if (roofTypeEl) {
                            roofTypeEl.textContent = building_type;
                        }

                        if (materialEl) {
                            materialEl.textContent = roof_material_text;
                        }

                        if (priceEl) {
                            priceEl.dataset.value = building_price;
                            priceEl.innerHTML = formatted_building_price;
                        }
                    });
                }


                let selected_service_text = popup.querySelector('.estimate-edit__services-item.active .estimate-edit__services-item-title').textContent.trim();
                buildingItem.querySelector('.estimate-edit__change-buildings-buildings__item-row-service .service-text').textContent = selected_service_text;
                let selected_service_data = popup.querySelector('.estimate-edit__services-item.active').dataset.service;
                document.querySelectorAll('.estimate-edit__roof-summary-building.building-' + buildingId + ' .estimate-edit__building-service-item').forEach(item => {
                    item.classList.add('excluded');
                });
                document.querySelector('.estimate-edit__roof-summary-building.building-' + buildingId + ' .estimate-edit__building-service-item-' + selected_service_data).classList.remove('excluded');

                let additional_service = popup.querySelector('.estimate-edit__popups-building-additional-service.active');
                if (additional_service) {
                    buildingItem.querySelector('.estimate-edit__change-buildings-buildings__item-row-service .additional-service').classList.add('active');
                    document.querySelector('.estimate-edit__roof-summary-building.building-' + buildingId + ' .estimate-edit__roof-summary-building-item-enova').classList.add('active');
                } else {
                    buildingItem.querySelector('.estimate-edit__change-buildings-buildings__item-row-service .additional-service').classList.remove('active');
                    document.querySelector('.estimate-edit__roof-summary-building.building-' + buildingId + ' .estimate-edit__roof-summary-building-item-enova').classList.remove('active');
                }

                SyncBuildingTotalPrice(buildingId);

            });
        });
    }
    //details popups

    let close_btns = document.querySelectorAll('.estimate-edit__popup .icon-close');
    if (close_btns.length) {
        close_btns.forEach(close_btn => {
            close_btn.addEventListener('click', function () {
                let enova_popup = document.querySelector('.estimate-edit__popups-enova.active');
                if (enova_popup) {
                    enova_popup.classList.remove('active');
                } else {
                    let popup = document.querySelector('.estimate-edit__popup.active');
                    popup.classList.remove('active');
                    overlay.classList.remove('active');
                    estimate_body.classList.remove('no-scroll');
                }
            });
        });
    }

    overlay.addEventListener('click', function () {
        let popups = document.querySelectorAll('.estimate-edit__popup.active');
        popups.forEach(popup => {
            popup.classList.remove('active');
        });
        overlay.classList.remove('active');
        estimate_body.classList.remove('no-scroll');
    });
    //popups

    //tooltips
    let tooltip_btns = document.querySelectorAll('.estimate-edit__tooltip-btn');
    if (tooltip_btns.length) {
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        tooltip_btns.forEach(btn => {
            const parent = btn.closest('.estimate-edit__tooltip');
            const content = parent.querySelector('.estimate-edit__tooltip-content');

            if (isTouchDevice) {
                // Close tooltip when clicking outside
                document.addEventListener('click', function (e) {
                    if (!parent.contains(e.target)) {
                        content.classList.remove('active');
                    }
                });

                // Mobile - toggle on click
                btn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    document.querySelectorAll('.estimate-edit__tooltip-content.active').forEach(el => {
                        if (el !== content) {
                            el.classList.remove('active');
                        }
                    });
                    content.classList.toggle('active');
                });
            } else {
                // Desktop - show/hide on hover
                btn.addEventListener('mouseenter', function () {
                    content.classList.add('active');
                });

                parent.addEventListener('mouseleave', function () {
                    content.classList.remove('active');
                });
            }
        });
    }
    //tooltips

    //roof-summary edit btn
    let roof_summary_edit_btns = document.querySelector('.estimate-edit__roof-summary .estimate-edit__edit-btn');
    if (roof_summary_edit_btns) {
        roof_summary_edit_btns.addEventListener('click', function (e) {
            showEditDetails();
        });
    }
    //roof-summary edit btn

    //change buildings
    //edit btn
    let change_buildings_edit_btn = document.querySelector('.estimate-edit__change-buildings .estimate-edit__edit-btn');
    if (change_buildings_edit_btn) {
        change_buildings_edit_btn.addEventListener('click', function (e) {
            showEditDetails();
        });
    }
    //mobile-nav
    let mobile_nav_item = document.querySelectorAll('.estimate-edit__change-buildings-mobile-nav .estimate-edit__change-buildings-mobile-nav__item');
    if (mobile_nav_item) {
        mobile_nav_item.forEach(item => {
            item.addEventListener('click', function (e) {
                //remove active from all items
                mobile_nav_item.forEach(item => {
                    item.classList.remove('active');
                });
                //add active to clicked item
                item.classList.add('active');

                //get buildingId from class
                let buildingClass = Array.from(item.classList).find(cls => cls.startsWith('building-'));
                let buildingId = buildingClass.replace('building-', '');

                document.querySelector('.estimate-edit__change-buildings-buildings__item').classList.add('mobile-hidden');
                document.querySelector('.estimate-edit__change-buildings-buildings__item.building-' + buildingId).classList.remove('mobile-hidden');

                setTimeout(() => {
                    fitMapToActiveBuildingMobile();
                }, 50);

            });
        });
    }
    //change buildings

    //visibility-btn
    let visibility_btns = document.querySelectorAll('.visibility-btn');
    if (visibility_btns.length) {
        visibility_btns.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let parent = e.target.closest('.estimate-edit__change-buildings-buildings__item');
                let buildingClass = Array.from(parent.classList).find(cls => cls.startsWith('building-'));
                let buildingId = buildingClass.replace('building-', '');

                let visibility_block = e.target.closest('.estimate-edit__change-buildings-buildings__item-visibility');
                visibility_block.classList.toggle('excluded');
                const buildingItems = document.querySelectorAll(`.building-${buildingId}`);
                buildingItems.forEach(buildingItem => {
                    buildingItem.classList.toggle('excluded');
                });

                checkBuildingsSelection(buildingId);
                //UpdateBuildingPrice(buildingId);
                updateBuildingsArea(buildingId);
                UpdatePopupDetailsTotals(buildingId);
                SyncBuildingTotalPrice(buildingId);
                UpdateTotalPrice();
                //console.log('Building visibility toggled. Excluded:', isExcluded);

            });
        });
    }

    //visibility-btn

    function formatWithVisualSpaces(number) {
        return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })
            .format(number)
            .split('\u202F')
            .map((part, i) =>
                i === 0 ? part : `<span class="num-space"></span>${part}`
            )
            .join('');
    }

    function updateMaterialDescription() {
        let popups = document.querySelectorAll('.estimate-edit__popups-building');
        popups.forEach(popup => {
            let selectItem = popup.querySelector('.estimate-edit__popups-building-material .estimate-edit__roof-material_materials-item.selected');
            if (!selectItem) return;
            popup.querySelector('.estimate-edit__popups-building-material-description .material-description').textContent = selectItem.dataset.description;
        });
    }

    function hideEditDetails() {
        let changeBuildings = document.querySelector('.estimate-edit__change-buildings');
        changeBuildings.classList.remove('active');
        let changeBuildingsContainer = changeBuildings.querySelector('.estimate-edit__change-buildings-container');
        changeBuildingsContainer.classList.remove('active');
        let detailsBlock = document.querySelector('.estimate-edit__change-buildings-details');
        detailsBlock.classList.remove('active');

        let header = document.querySelector('.estimate-edit__header');
        let roofSummary = document.querySelector('.estimate-edit__roof-summary');
        header.classList.remove('blur');
        roofSummary.classList.remove('blur');
        let footer = document.querySelector('.estimate-edit__footer');
        footer.classList.remove('hidden');

        header.scrollIntoView({
            behavior: 'smooth'
        });
    }

    function showEditDetails() {
        let changeBuildings = document.querySelector('.estimate-edit__change-buildings');
        changeBuildings.classList.add('active');
        let changeBuildingsContainer = changeBuildings.querySelector('.estimate-edit__change-buildings-container');
        changeBuildingsContainer.classList.add('active');
        let detailsBlock = document.querySelector('.estimate-edit__change-buildings-details');
        detailsBlock.classList.add('active');

        let header = document.querySelector('.estimate-edit__header');
        let roofSummary = document.querySelector('.estimate-edit__roof-summary');
        header.classList.add('blur');
        roofSummary.classList.add('blur');
        let footer = document.querySelector('.estimate-edit__footer');
        footer.classList.add('hidden');

        checkMapInit();

        //smooth scroll to changeBuildingsContainer
        changeBuildingsContainer.scrollIntoView({
            behavior: 'smooth'
        });
        document.addEventListener('scrollend', function handleScrollEnd() {
            document.removeEventListener('scrollend', handleScrollEnd);
            console.log("Smooth scroll finished!");
            header.classList.add('hidden');
            roofSummary.classList.add('hidden');
            footer.classList.add('hidden');
            document.querySelector('header.header').classList.add('hidden');
        });
    }

    function updateOddClassesServiceItems() {
        const containers = document.querySelectorAll('.estimate-edit__services-items');

        containers.forEach(container => {
            const items = container.querySelectorAll('.estimate-edit__services-item');
            items.forEach(item => item.classList.remove('odd'));

            const visibleItems = Array.from(items).filter(el => !el.classList.contains('excluded'));

            visibleItems.forEach((el, index) => {
                if ((index + 1) % 2 === 1) {
                    el.classList.add('odd');
                }
            });
        });

    }

    function updateServicePrices(popup, selectItem, buildingId) {
        //update service prices
        let replace_price = selectItem.dataset.replace;
        popup.querySelector('.estimate-edit__services-item-replace .price_value').dataset.value = replace_price;
        let rehab_price = selectItem.dataset.rehab;
        popup.querySelector('.estimate-edit__services-item-rehab .price_value').dataset.value = rehab_price;

        let formatted_replace = formatWithVisualSpaces(replace_price);
        let formatted_rehab = formatWithVisualSpaces(rehab_price);
        popup.querySelector('.estimate-edit__services-item-replace .price_value').innerHTML = formatted_replace;
        popup.querySelector('.estimate-edit__services-item-rehab .price_value').innerHTML = formatted_rehab;

        UpdatePopupDetailsTotals(buildingId);
        updateMaterialDescription();
    }

    function UpdatePopupDetailsTotals(buildingId) {
        let popup = document.querySelector('.estimate-edit__popups-building-' + buildingId);

        //service
        let selected_service = popup.querySelector('.estimate-edit__services-item.active');
        let service_price = selected_service.querySelector('.price_value').dataset.value;
        //additional service
        let additional_service_price = 0;
        //let additional_service = popup.querySelector('.estimate-edit__additional-services.active:not(.hidden)');
        let additional_service = popup.querySelector('.estimate-edit__additional-services.active');
        if (additional_service) {
            additional_service_price = additional_service.querySelector('.estimate-edit__additional-services-price .enova_price_value').dataset.value;
            /*
            let new_total_price = service_price - additional_service_price;
            let formatted_additional_service_price = new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(new_total_price);
            additional_service.querySelector('.estimate-edit__additional-services-price .price_value').dataset.value = new_total_price;
            additional_service.querySelector('.estimate-edit__additional-services-price .price_value').textContent = formatted_additional_service_price;
            if (additional_service.classList.contains('active') && !additional_service.classList.contains('hidden')) {
                service_price = new_total_price;
            }
             */
            service_price = Number(service_price) + Number(additional_service_price);
        }

        let formatted_price = formatWithVisualSpaces(service_price);

        //totals
        let totals = popup.querySelector('.estimate-edit__popups-building-price');
        totals.querySelector('.building_price_value').dataset.value = service_price;
        totals.querySelector('.building_price_value').innerHTML = formatted_price;

    }

    function SyncBuildingTotalPrice(buildingId) {
        let popup = document.querySelector('.estimate-edit__popups-building-' + buildingId);
        let totals = popup.querySelector('.estimate-edit__popups-building-price .building_price_value');
        let service_price = totals.dataset.value;
        let formatted_price = formatWithVisualSpaces(service_price);
        document.querySelectorAll('.building-' + buildingId + ' .building_price_value').forEach(price => {
            price.dataset.value = service_price;
            price.innerHTML = formatted_price;
        });

        UpdateTotalPrice();
    }

    function updateServicesText() {
        //set excluded to all services for all buildings
        let buildings = document.querySelectorAll('.estimate-edit__updated-estimate-buildings-item');
        buildings.forEach(building => {
            let services = building.querySelectorAll('.estimate-edit__updated-estimate-buildings-item-services-main .estimate-edit__updated-estimate-buildings-item-value');
            services.forEach(service => {
                service.classList.add('excluded');
            });
        });
        //get active main service
        let main_service = document.querySelectorAll('.estimate-edit__services-items > .active');
        let unique_services = [];
        main_service.forEach(service => {
            let service_name = service.querySelector('.estimate-edit__services-item-title').textContent.trim();
            if (!unique_services.includes(service_name)) {
                unique_services.push(service_name);
            }
            //get active buildings
            let serviceClass = Array.from(service.classList).find(cls => cls.startsWith('estimate-edit__services-item-'));
            let serviceId = serviceClass.replace('estimate-edit__services-item-', '');

            let active_buildings = service.querySelectorAll('.estimate-edit__services-item__buildings-item.active');
            active_buildings.forEach(building => {
                let buildingClass = Array.from(building.classList).find(cls => cls.startsWith('building-'));
                let buildingId = buildingClass.replace('building-', '');
                let service_obj = document.querySelector('.estimate-edit__updated-estimate-buildings-item.building-' + buildingId + ' .estimate-edit__updated-estimate-buildings-item-value-' + serviceId);
                service_obj.classList.remove('excluded');
            });
        });
        //get active additional service
        let additional_service = document.querySelectorAll('.estimate-edit__updated-estimate-buildings-item .estimate-edit__updated-estimate-buildings-item-services-additional:not(.excluded)');
        additional_service.forEach(service => {
            let service_name = service.querySelector('.estimate-edit__updated-estimate-buildings-item-value').textContent.trim();
            if (!unique_services.includes(service_name)) {
                unique_services.push(service_name);
            }
        });
        //console.log(unique_services);
        let services_obj = document.querySelector('.estimate-edit__roof-summary-item-services');
        if (services_obj) {
            services_obj.querySelector('.estimate-edit__roof-summary-item-value').textContent = unique_services.join(', ');
        }
    }

    function checkSelectedRoofs(buildingId) {
        //get selected roofs from calculatorState.buildigns by buildingId
        const building = calculatorState.buildings.find(building => building.ByggId === buildingId);
        const selectedRoofs = building.roofs.filter(roof => roof.selected);

        //return is excluded state
        return selectedRoofs.length === 0;
    }

    function updateBuildingVisibility(buildingId) {
        let isExcluded = checkSelectedRoofs(buildingId);

        //update visibility block
        const visibilityBlock = document.querySelector(`.estimate-edit__change-buildings-buildings__item.building-${buildingId} .estimate-edit__change-buildings-buildings__item-visibility`);
        if (visibilityBlock) {
            if (isExcluded) {
                visibilityBlock.classList.add('excluded')
            } else {
                visibilityBlock.classList.remove('excluded')
            }
        }

        //update all buildings
        const buildingItems = document.querySelectorAll(`.building-${buildingId}`);
        buildingItems.forEach(buildingItem => {
            if (isExcluded) {
                buildingItem.classList.add('excluded');
            } else {
                buildingItem.classList.remove('excluded');
            }
        });
    }

    function checkSameMaterials() {
        let materialItem = document.querySelector('.estimate-edit__roof-summary-item-material');
        if (materialItem) {
            let materialTextItems = materialItem.querySelectorAll('.estimate-edit__roof-summary-item-value');
            let materialText = materialTextItems[0].querySelector('.material_text').textContent.trim();
            materialTextItems.forEach((item, index) => {
                if (index === 0) {
                    return;
                }
                if (item.querySelector('.material_text').textContent.trim() === materialText) {
                    item.classList.add('excluded');
                } else {
                    item.classList.remove('excluded');
                }
            });
        }
    }

    //calculation prices
    function getClearingRate(area) {
        if (area < 100) {
            return 70;
        }
        if (area < 200) {
            return 55;
        }
        if (area < 400) {
            return 50;
        }
        return 45;
    }

    function getServiceDiscount(area) {
        if (area > 1000) {
            return 0.85;
        } else if (area > 500) {
            return 0.90;
        } else if (area > 300) {
            return 0.95;
        } else {
            return 1.00;
        }
    }

    function getPriceForBuilding(building, calculatorStateTemp) {
        /**
         * ------
         */
        const buildingId = building.ByggId;
        /**
         * Complexity score
         */
        let complexityScore = 1;
        complexityScore = parseFloat(building?.ComplexityScore) || 1;

        /**
         * Base prices
         */
        const basePricePerM2Replace = parseFloat(wdsCalculatorData.pricing.base_price_m2_replace) || 0;
        const basePricePerM2Rehab = parseFloat(wdsCalculatorData.pricing.base_price_m2_rehab) || 0;

        /**
         * Total area
         */
        const selectedRoofs = (building.roofs || []).filter(roof => roof.selected);
        const area = Math.floor(selectedRoofs.reduce((sum, roof) => sum + (parseFloat(roof.area) || 0), 0));

        /**
         * Roof age
         */
            //const roofAgeSelected = calculatorStateTemp.selections.roofAge;
        const roofAgeSelected = building.roofAge;
        const roofAgeMultiplier = parseFloat(wdsCalculatorData.pricing.roof_age_multipliers[roofAgeSelected]) || 1;

        /**
         * Building type
         */
        const buildingTypeSelected = calculatorStateTemp.selections.buildingType;
        const buildingTypeMultiplier = parseFloat(wdsCalculatorData.pricing.building_type_multipliers[buildingTypeSelected]) || 1;

        /**
         * Pitch
         */
        let maxPitch = 0;
        let minPitch = 0;
        const pitchSum = selectedRoofs.reduce((sum, roof) => {
            const roofPitch = roof.facetData && typeof roof.facetData.Helning !== 'undefined' ? parseFloat(roof.facetData.Helning) || 0 : 0;

            if (roofPitch > maxPitch) {
                maxPitch = roofPitch;
            }
            if (roofPitch < minPitch || minPitch === 0) {
                minPitch = roofPitch;
            }

            return sum + roofPitch;
        }, 0);

        const pitch = Math.round(pitchSum / selectedRoofs.length);

        /**
         * Material Price
         */
        const materialSlug = calculatorStateTemp.selections.materials[buildingId];
        const materialPriceRange = wdsCalculatorData.pricing.materials[materialSlug];

        const minPrice = parseFloat(materialPriceRange.min_price) || 0;
        const maxPrice = parseFloat(materialPriceRange.max_price) || 0;
        const materialPriceFinal = Math.round(minPrice + (maxPrice - minPrice) * ((complexityScore - 1.0) / 0.3));

        /**
         * Add Ons
         */
        const services = calculatorStateTemp.selections.services[buildingId] || [];
        const servicesPricing = wdsCalculatorData.pricing.additional_services;
        const servicesPrices = {};

        let addOns = services.reduce((sum, service) => {
            let foundSlug = Object.keys(servicesPricing).find(slug => servicesPricing[slug].name === service.name);
            if (foundSlug) {
                let servicePricingItem = servicesPricing[foundSlug];
                let price = parseFloat(servicePricingItem.price) || 0;
                servicesPrices[service.name] = price * service.quantity;
                sum += price * service.quantity;
            }
            return sum;
        }, 0);

        /**
         * Full Replacement formula
         */
        let replace = area * (basePricePerM2Replace + materialPriceFinal) * complexityScore * roofAgeMultiplier * buildingTypeMultiplier + addOns;

        /**
         * Rehab formula
         */
        let rehab = area * (basePricePerM2Rehab + materialPriceFinal) * complexityScore * roofAgeMultiplier * buildingTypeMultiplier + addOns;

        /**
         * Additional multipliers by pitch and number of facets
         */
        let more_than_facets = '';
        let more_than_pitch = '';

        const facetsThreshold = parseInt(wdsCalculatorData.pricing.more_than_facets) || 4;
        const pitchThreshold = parseInt(wdsCalculatorData.pricing.more_than_pitch) || 45;

        if (selectedRoofs.length > facetsThreshold) {
            const facetsMultiplier = parseFloat(wdsCalculatorData.pricing.more_than_facets_multiplier) || 1.1;
            replace = replace * facetsMultiplier;
            rehab = rehab * facetsMultiplier;
            more_than_facets = ' | More than ' + facetsThreshold + ' facets then increase by ' + facetsMultiplier;
        }

        if (pitch > pitchThreshold) {
            const pitchMultiplier = parseFloat(wdsCalculatorData.pricing.more_than_pitch_multiplier) || 1.15;
            replace = replace * pitchMultiplier;
            rehab = rehab * pitchMultiplier;
            more_than_pitch = ' | More than ' + pitchThreshold + ' pitch then increase by ' + pitchMultiplier;
        }

        //console.log(`[getPriceForBuilding] replace formula: Area: ${area} * (Base Price: ${basePricePerM2Replace} + Material Price: ${materialPriceFinal}) * Complexity Score: ${complexityScore} * Roof Age Multiplier: ${roofAgeMultiplier} * Building Type Multiplier: ${buildingTypeMultiplier} + Add Ons: ${addOns} ${more_than_facets} ${more_than_pitch}`);
        //console.log(`[getPriceForBuilding] rehab formula: Area: ${area} * (Base Price: ${basePricePerM2Rehab} + Material Price: ${materialPriceFinal}) * Complexity Score: ${complexityScore} * Roof Age Multiplier: ${roofAgeMultiplier} * Building Type Multiplier: ${buildingTypeMultiplier} + Add Ons: ${addOns} ${more_than_facets} ${more_than_pitch}`);

        const pricingData = {
            buildingId: buildingId,
            rehab: Math.round(rehab),
            replace: Math.round(replace),
            totalArea: area
        }

        return pricingData;
    }

    function updateBuildingsArea(buildingId) {
        let building = calculatorState.buildings.find(building => building.ByggId === buildingId);
        const calculatorStateTemp = JSON.parse(JSON.stringify(calculatorState));
        let pricing = getPriceForBuilding(building, calculatorStateTemp);

        if (pricing.totalArea === 0) {
            updateBuildingVisibility(buildingId);
        }

        //update building area
        let buildingArea = document.querySelectorAll(`.building-${buildingId} .building_area_value`);
        if (buildingArea.length) {
            buildingArea.forEach(area => {
                area.textContent = pricing.totalArea;
            });
        }
        //update building area in a detailed popup
        let detailedPopupArea = document.querySelector(`.estimate-edit__popups-building-${buildingId} .building_area_value`);
        if (detailedPopupArea) {
            detailedPopupArea.textContent = pricing.totalArea;
        }

        //update total area
        let totalArea = 0;
        let buildings = document.querySelectorAll('.estimate-edit__change-buildings-buildings .estimate-edit__change-buildings-buildings__item');
        if (buildings.length) {
            buildings.forEach(building => {
                totalArea += parseInt(building.querySelector('.building_area_value').textContent);
            });
        }
        let totalAreaElement = document.querySelector('.estimate-edit__roof-summary .total_area_value');
        if (totalAreaElement) {
            totalAreaElement.textContent = totalArea;
        }

        //update main services
        let detailed_popup = document.querySelector(`.estimate-edit__popups-building-${buildingId}`);
        //update replace
        let replaceItem = detailed_popup.querySelector(`.estimate-edit__services-item-replace`);
        if (replaceItem) {
            let formatted_replace = formatWithVisualSpaces(pricing.replace);
            let priceItem = replaceItem.querySelector('.price_value');
            priceItem.dataset.value = pricing.replace;
            priceItem.innerHTML = formatted_replace;
        }
        //update rehab
        let rehabItem = detailed_popup.querySelector(`.estimate-edit__services-item-rehab`);
        if (rehabItem) {
            let formatted_rehab = formatWithVisualSpaces(pricing.rehab);
            let priceItem = rehabItem.querySelector('.price_value');
            priceItem.dataset.value = pricing.rehab;
            priceItem.innerHTML = formatted_rehab;
        }
        //update cleaning
        let cleaningItem = detailed_popup.querySelector(`.estimate-edit__services-item-cleaning`);
        if (cleaningItem) {
            let total_area = parseInt(pricing.totalArea);
            const rate = getClearingRate(total_area);
            const raw = total_area * rate * building.ComplexityScore * getServiceDiscount(total_area);
            const total = Math.max(5000, raw);
            let cleaning_price = Math.round(total / 100) * 100;
            let formatted_cleaning = formatWithVisualSpaces(cleaning_price);
            let priceItem = cleaningItem.querySelector('.price_value');
            priceItem.dataset.value = cleaning_price;
            priceItem.innerHTML = formatted_cleaning;
        }
        //update renew
        let takfornyingItem = detailed_popup.querySelector(`.estimate-edit__services-item-renew`);
        if (takfornyingItem) {
            let $takfornying_k = 410;
            let renew_price = pricing.totalArea * $takfornying_k;
            let formatted_renew = formatWithVisualSpaces(renew_price);
            let priceItem = takfornyingItem.querySelector('.price_value');
            priceItem.dataset.value = renew_price;
            priceItem.innerHTML = formatted_renew;
        }
        //update main services

        //update materials
        let materials = detailed_popup.querySelectorAll(`.estimate-edit__roof-material_materials-item`);
        if (materials.length) {
            materials.forEach(material => {
                const calculatorStateMaterialsTemp = JSON.parse(JSON.stringify(calculatorState));
                //get material_id from classname begins with material-
                let materialClass = Array.from(material.classList).find(cls => cls.startsWith('material-'));
                let materialId = materialClass.replace('material-', '');
                //console.log(materialId);
                calculatorStateMaterialsTemp.selections.materials[buildingId] = materialId;
                let temp_pricing = getPriceForBuilding(building, calculatorStateMaterialsTemp);
                //console.log(temp_pricing);
                //material.querySelector('.replace_' + buildingId).value = temp_pricing.replace;
                //material.querySelector('.rehab_' + buildingId).value = temp_pricing.rehab;
                material.dataset.replace = temp_pricing.replace;
                material.dataset.rehab = temp_pricing.rehab;
            });
        }

        //update additional service
        updateEnovaCalculations(buildingId);
    }

    function weightedComplexity(complexityFactor) {
        // Input range: 1.00–1.30
        // Effective output range: approx. 1.00–1.18
        return 1 + (Number(complexityFactor) - 1) * 0.6;
    }

    function buildingTypeFactor(buildingType) {
        switch (buildingType) {
            case "borettslag-sameie":
                return 0.95;
            case "naeringseiendom":
                return 0.98;
            default:
                return 1.00; // privat
        }
    }

    function calculateInsulation({
                                     roofArea,
                                     complexityFactor,
                                     buildingType,
                                     mainService
                                 }) {
        const isAddOn = mainService === wdsCalculatorData.JobType.replace_title;
        const baseRate = isAddOn ? wdsCalculatorData.pricing.base_price_m2_insulation_addon : wdsCalculatorData.pricing.base_price_m2_loft_insulation;
        const minJobPrice = isAddOn ? 20000 : 25000;
        const minPerM2 = isAddOn ? 300 : 350;
        const maxPerM2 = isAddOn ? 900 : 1100;

        const complexity = weightedComplexity(complexityFactor);
        const buildingFactor = buildingTypeFactor(buildingType);

        const rawPrice =
            Number(roofArea) *
            Number(baseRate) *
            complexity *
            buildingFactor;

        const withMinimum = Math.max(rawPrice, minJobPrice);

        const pricePerM2 = withMinimum / roofArea;
        const clampedPerM2 =
            Math.min(maxPerM2, Math.max(minPerM2, pricePerM2));

        const finalPrice = clampedPerM2 * roofArea;

        return {
            insulationMode: isAddOn
                ? "addon-during-roof-replacement"
                : "loft-insulation",
            insulationVisible: true,
            insulationEstimatedPrice:
                Math.round(finalPrice / 500) * 500
        };
    }

    function calculateEnovaSupport({
                                       insulationPrice,
                                       roofArea,
                                       roofAge,
                                       buildingType
                                   }) {
        const eligible =
            buildingType === "privat" &&
            roofAge === "Mer enn 30 år";

        if (!eligible) {
            return {
                enovaEligible: false,
                enovaSupportEstimated: 0
            };
        }

        const areaCap = Math.min(roofArea, 150);
        const supportByArea = areaCap * 150;
        const supportByPercent = insulationPrice * 0.25;

        const support = Math.min(
            supportByArea,
            supportByPercent,
            22500
        );

        return {
            enovaEligible: true,
            enovaSupportEstimated:
                Math.round(support / 100) * 100
        };
    }

    function updateEnovaCalculations(buildingId) {
        let detailed_popup = document.querySelector(`.estimate-edit__popups-building-${buildingId}`);
        let additionalService = detailed_popup.querySelector(`.estimate-edit__additional-services`);
        let building = calculatorState.buildings.find(building => building.ByggId === buildingId);
        const selectedRoofs = (building.roofs || []).filter(roof => roof.selected);
        const total_area = Math.floor(selectedRoofs.reduce((sum, roof) => sum + (parseFloat(roof.area) || 0), 0));
        let main_service = detailed_popup.querySelector('.estimate-edit__services-item.active .estimate-edit__services-item-title').textContent.trim();
        let current_roof_age = detailed_popup.querySelector('.estimate-edit__popups-building-age .estimate-edit__popups-building-value.value-btn .value').textContent.trim();

        let buildingType = outputJson.BuildingType || 'Ukjent';
        let calculate_insulation = calculateInsulation({
            'roofArea': total_area,
            'complexityFactor': building.ComplexityScore,
            'buildingType': buildingType,
            'mainService': main_service
        });
        console.log('calculate_insulation', calculate_insulation);

        let enova = calculateEnovaSupport({
            'insulationPrice': calculate_insulation.insulationEstimatedPrice,
            'roofArea': total_area,
            'roofAge': current_roof_age,
            'buildingType': buildingType
        });
        console.log('enova', enova);

        additionalService.dataset.insulationmode = calculate_insulation.insulationMode;
        additionalService.dataset.insulationestimatedprice = calculate_insulation.insulationEstimatedPrice;
        additionalService.dataset.insulationvisible = calculate_insulation.insulationVisible;
        additionalService.dataset.enovavisible = enova.enovaVisible;
        additionalService.dataset.enovasupportestimated = enova.enovaSupportEstimated;

        //let add_price = Math.min(total_area, 150) * 150;
        let add_price = enova.enovaSupportEstimated;
        let priceItem = additionalService.querySelector('.estimate-edit__additional-services-enova-title .enova_price_value');
        if (priceItem) {
            priceItem.dataset.value = add_price;
            priceItem.innerHTML = formatWithVisualSpaces(add_price);

            let TotalpriceItem = additionalService.querySelector('.estimate-edit__additional-services-price .enova_price_value');
            let formatted_additionalService = formatWithVisualSpaces(calculate_insulation.insulationEstimatedPrice);
            TotalpriceItem.dataset.value = calculate_insulation.insulationEstimatedPrice;
            TotalpriceItem.innerHTML = formatted_additionalService;
        }
    }

    /*
    function UpdateBuildingPrice(buildingID) {
        const buildingPrice = document.querySelector(`.estimate-edit__updated-estimate-buildings-item.building-${buildingID} .building_price_value`);
        if (!buildingPrice) {
            console.warn(`Building price element not found for building ${buildingID}`);
            return;
        }

        let totalPrice = 0;

        // Calculate main service price for selected facets
        const mainServicePrices = document.querySelectorAll(`.estimate-edit__services-item.active:not(.excluded) .building-${buildingID}.active:not(.excluded) .price_value`);
        let mainServiceTotal = 0;

        if (mainServicePrices.length) {
            mainServicePrices.forEach(priceEl => {
                mainServiceTotal += parseInt(priceEl.dataset.value) || 0;
            });
        }

        // Calculate additional service price
        let additionalServicePrice = document.querySelector(`.estimate-edit__additional-services-buildings-item.building-${buildingID}.active .price_value`);
        let additionalServiceTotal = additionalServicePrice ? parseInt(additionalServicePrice.dataset.value) || 0 : 0;

        totalPrice = mainServiceTotal - additionalServiceTotal;

        const formattedPrice = new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(totalPrice);

        buildingPrice.dataset.value = totalPrice;
        buildingPrice.textContent = formattedPrice;

        //update additional formatted price
        additionalServicePrice = document.querySelector(`.estimate-edit__additional-services-buildings-item.building-${buildingID} .price_value`);
        if (additionalServicePrice) {
            additionalServiceTotal = parseInt(additionalServicePrice.dataset.value);
            let formattedAdditionalPrice = new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(mainServiceTotal - additionalServiceTotal);
            additionalServicePrice.textContent = formattedAdditionalPrice;
        }

        UpdateTotalPrice();
    }
    */

    function UpdateTotalPrice() {
        const buildingPrices = document.querySelectorAll('.estimate-edit__change-buildings-buildings__item:not(.excluded) .estimate-edit__change-buildings-buildings__item-row-total .building_price_value');
        let totalPrice = 0;
        buildingPrices.forEach(price => {
            let b_price = price.dataset.value;
            totalPrice += parseInt(b_price);
        });
        let formattedPrice = formatWithVisualSpaces(totalPrice);
        const total_prices = document.querySelectorAll('.total_price_value');
        total_prices.forEach(price => {
            price.innerHTML = formattedPrice;
            price.dataset.value = totalPrice;
        });

        //get count active buildings
        let activeBuildingsCount = document.querySelectorAll('.estimate-edit__change-buildings-buildings__item:not(.excluded)').length;
        document.querySelector('.estimate-edit__updated-estimate-included .building_count').textContent = activeBuildingsCount;

        updateJsonData();
    }

    function updateJsonData() {
        //get buildings ids
        calculatorState.buildings.forEach((building, index) => {
            let buildingId = building.ByggId;
            let building_obj = document.querySelector(`.estimate-edit__change-buildings-buildings__item.building-${buildingId}`);
            let popup = document.querySelector('.estimate-edit__popups-building-' + buildingId);
            //update roofAge
            let roofAge = popup.querySelector(`.estimate-edit__popups-building-age .estimate-edit__popups-building-value.value-btn .value`);
            if (roofAge) {
                building.RoofAge = roofAge.textContent.trim();
                outputJson.Buildings[index].RoofAge = roofAge.dataset.value;
                outputJson.Buildings[index].RoofAgeNO = roofAge.textContent.trim();
            }
            //update area
            let area = building_obj.querySelector(`.building_area_value`).textContent;
            if (area) {
                building.selected_roof_area = area;
                outputJson.Buildings[index].RoofArea = area;
            }
            //update material
            let material = building_obj.querySelector(`.estimate-edit__change-buildings-buildings__item-material .estimate-edit__change-buildings-buildings__item-row-value`).textContent.trim();
            if (material) {
                building.Material = material;
                outputJson.Buildings[index].Material = material;
            }
            //update jobtype
            let service_text_obj = building_obj.querySelector(`.estimate-edit__change-buildings-buildings__item-row-service .service-text`);
            if (service_text_obj) {
                let service_title = service_text_obj.textContent.trim();
                building.JobType = service_title;
                outputJson.Buildings[index].JobType = service_title;
            }
            //update Price_Takbytte
            let price_takbytte = popup.querySelector(`.estimate-edit__services-item-replace .price_value`);
            if (price_takbytte) {
                building.EstimatedPrice_Takbytte = price_takbytte.dataset.value;
                outputJson.Buildings[index].EstimatedPrice_Takbytte = price_takbytte.dataset.value;
            }
            //update Price_Rehab
            let price_rehab = popup.querySelector(`.estimate-edit__services-item-rehab .price_value`);
            if (price_rehab) {
                building.EstimatedPrice_Rehab = price_rehab.dataset.value;
                outputJson.Buildings[index].EstimatedPrice_Rehab = price_rehab.dataset.value;
            }
            //update Price_Takfornying
            let price_takfornying = popup.querySelector(`.estimate-edit__services-item-renew .price_value`);
            if (price_takfornying) {
                building.EstimatedPrice_Takfornying = price_takfornying.dataset.value;
                outputJson.Buildings[index].EstimatedPrice_Takfornying = price_takfornying.dataset.value;
            }
            //update Price_Cleaning
            let price_cleaning = popup.querySelector(`.estimate-edit__services-item-cleaning .price_value`);
            if (price_cleaning) {
                building.EstimatedPrice_Cleaning = price_cleaning.dataset.value;
                outputJson.Buildings[index].EstimatedPrice_Cleaning = price_cleaning.dataset.value;
            }
            //update enova
            let enova_parent = popup.querySelector(`.estimate-edit__additional-services`);
            let enova_item = popup.querySelector(`.estimate-edit__additional-services.active .estimate-edit__additional-services-enova-title .enova_price_value`);
            if (enova_item) {
                building.Enova_selected = true;
                outputJson.Buildings[index].Enova_selected = true;
                //building.Enova_price = enova_item.dataset.value;
                //outputJson.Buildings[index].Enova_price = enova_item.dataset.value;
            } else {
                building.Enova_selected = false;
                outputJson.Buildings[index].Enova_selected = false;
                //building.Enova_price = 0;
                //outputJson.Buildings[index].Enova_price = 0;
            }
            building.insulationMode = enova_parent.dataset.insulationmode;
            building.insulationVisible = enova_parent.dataset.insulationvisible;
            building.insulationEstimatedPrice = enova_parent.dataset.insulationestimatedprice;
            building.enovaEligible = enova_parent.dataset.enovaeligible;
            building.enovaSupportEstimated = enova_parent.dataset.enovasupportestimated;
            outputJson.Buildings[index].insulationMode = enova_parent.dataset.insulationmode;
            outputJson.Buildings[index].insulationVisible = enova_parent.dataset.insulationvisible;
            outputJson.Buildings[index].insulationEstimatedPrice = enova_parent.dataset.insulationestimatedprice;
            outputJson.Buildings[index].enovaEligible = enova_parent.dataset.enovaeligible;
            outputJson.Buildings[index].enovaSupportEstimated = enova_parent.dataset.enovasupportestimated;

            //get building total
            let total_el = popup.querySelector('.estimate-edit__popups-building-price .building_price_value');
            if (total_el) {
                building.EstimatedPrice_Total = total_el.dataset.value;
                outputJson.Buildings[index].EstimatedPrice_Total = total_el.dataset.value;
            }

            //update outputJson total price
            let total_price = document.querySelector(`.estimate-edit__updated-estimate .total_price_value`);
            if (total_price) {
                outputJson.Total_EstimatedPrice = Number(total_price.dataset.value);
            }
            //update outputJson.RoofFacets based on calculatorState.selectedRoofFacets by buildingId
            outputJson.Buildings[index].RoofFacets = building.roofs
                .filter(roof => roof.selected)
                .map((roof, i) => ({
                    Id: roof.id || i + 1,
                    Areal: parseFloat(roof.area) || 0,
                    Helning: parseFloat(roof.facetData?.Helning) || 0,
                    Materiale: calculatorState.selections.materials[buildingId],
                    Retning: roof.facetData?.Retning || '',
                    Lengde: parseFloat(roof.facetData?.Lengde) || 0,
                    Bredde: parseFloat(roof.facetData?.Bredde) || 0
                }));
        })
    }

    //calculation prices


    //map
    function checkMapInit() {
        // Small delay to ensure the container is visible before initializing
        setTimeout(() => {
            if (!mapInstance) {
                initMap();
            } else {
                // If map already exists, just refresh it
                setTimeout(() => {
                    mapInstance.invalidateSize();
                }, 100);
            }
        }, 50);
        setTimeout(() => {
            fitMapToActiveBuildingMobile();
        }, 100);
    }

    // Create a mapping between building IDs and their index
    function getBuildingIndexMap() {
        const indexMap = {};
        if (outputJson && outputJson.Buildings) {
            outputJson.Buildings.forEach((building, index) => {
                const buildingId = building.id || building.ID; // Handle both cases
                if (building && buildingId) {
                    indexMap[buildingId] = index;
                }
            });
        }
        return indexMap;
    }

    function checkBuildingsSelection(buildingId) {
        // Get all building items
        const buildingItem = document.querySelector('.estimate-edit__change-buildings-buildings__item.building-' + buildingId);
        //const buildingIndexMap = getBuildingIndexMap();

        const isExcluded = buildingItem.classList.contains('excluded');

        // Find all facets for this building
        const buildingFacetIds = Object.keys(facetMap).filter(id =>
            facetMap[id].buildingId === buildingId
        );

        // Update each facet's state
        buildingFacetIds.forEach(facetId => {
            const facet = facetMap[facetId];
            if (facet && facet.polygon) {
                const styles = getPolygonStyles(facet.buildingIndex);

                // If the building is excluded, all its facets are excluded
                // Otherwise, respect the individual facet's selection state
                const shouldBeSelected = !isExcluded;

                styles.fillOpacity = shouldBeSelected ? 0.9 : 0.3;
                styles.weight = shouldBeSelected ? 2 : 1;

                facet.polygon.setStyle(styles);

                if (shouldBeSelected) {
                    facet.polygon.bringToFront();
                }

                facetMap[facetId] = {
                    polygon: facet.polygon,
                    isSelected: shouldBeSelected,
                    buildingId: facet.buildingId,
                    buildingIndex: facet.buildingIndex
                };

                // Update the UI to reflect the facet's state
                //updateFacetUIState(facetId, shouldBeSelected);
            }
        });

        //set selected status for roofs in calculatorState by buildingId
        calculatorState.buildings.forEach(building => {
            if (building.ByggId === buildingId) {
                building.roofs.forEach(roof => {
                    roof.selected = !isExcluded;
                });
            }
        });
    }

    function getPolygonStyles(buildingIndex = 0) {
        const baseColor = BUILDING_COLORS[buildingIndex % BUILDING_COLORS.length];
        return {
            color: '#000000',
            weight: 1.5,
            opacity: 1,
            fillColor: baseColor,
            fillOpacity: 0.6,
            dashArray: null
        };
    }

    // Function to get bounds from coordinates
    function getBoundsFromCoordinates(coordinates) {
        let minLat = Infinity, maxLat = -Infinity, minLng = Infinity, maxLng = -Infinity;

        // Flatten the coordinates array and find min/max values
        coordinates.forEach(polygon => {
            polygon.forEach(coord => {
                const lat = coord[1];
                const lng = coord[0];
                minLat = Math.min(minLat, lat);
                maxLat = Math.max(maxLat, lat);
                minLng = Math.min(minLng, lng);
                maxLng = Math.max(maxLng, lng);
            });
        });

        return [[minLat, minLng], [maxLat, maxLng]];
    }

    function getActiveBuildingIdFromMobileUI() {
        if (window.innerWidth >= 768) return null;

        const activeEl = document.querySelector(
            '.estimate-edit__change-buildings.active .estimate-edit__change-buildings-mobile-nav__item.active'
        );

        if (!activeEl) return null;

        const classList = Array.from(activeEl.classList);
        const buildingClass = classList.find(c => c.startsWith('building-'));

        if (!buildingClass) return null;

        return buildingClass.replace('building-', '');
    }

    function fitMapToActiveBuildingMobile() {
        if (window.innerWidth >= 768) return;
        if (!mapInstance || !facetMap) return;

        const activeByggId = getActiveBuildingIdFromMobileUI();
        if (!activeByggId) return;

        const activePolygons = Object.values(facetMap)
            .filter(item => String(item.buildingId) === String(activeByggId))
            .map(item => item.polygon)
            .filter(Boolean);

        if (!activePolygons.length) return;

        const group = L.featureGroup(activePolygons);

        mapInstance.fitBounds(group.getBounds(), {
            paddingTopLeft: [0, 0],
            paddingBottomRight: [0, 0],
            maxZoom: 22,
            animate: true
        });
    }

    function initMap() {
        // Check if Leaflet is loaded
        if (typeof L === 'undefined') {
            console.error('Leaflet is not loaded.');
            return;
        }

        const apiKey = window.wdsCalculatorData.apiKeys.map ?? '';
        if (!apiKey) {
            console.error('Map API key not found.');
            return;
        }

        const mapPlaceholder = document.querySelector('.estimate-edit__map-placeholder');
        if (!mapPlaceholder) {
            console.error('Map placeholder not found.');
            return;
        }

        let center, zoom;
        let longitude = outputJson.Tech.CoordinateY;
        let latitude = outputJson.Tech.CoordinateX;
        if (!latitude || !longitude) {
            console.error('Map coordinates not found.');
            return;
        }

        center = [latitude, longitude];
        zoom = 21;

        mapInstance = L.map(mapPlaceholder, {
            zoomControl: false,
            scrollWheelZoom: false
        }).setView(center, zoom);

        const satelittLayer = L.tileLayer(
            `https://waapi.webatlas.no/maptiles/tiles/webatlas-orto-newup/wa_grid/{z}/{x}/{y}.jpeg?APITOKEN=${apiKey}`,
            {
                maxZoom: 22,
                minZoom: 15,
            }
        );

        const kartLayer = L.tileLayer(
            `https://waapi.webatlas.no/maptiles/tiles/webatlas-gray-vektor/wa_grid/{z}/{x}/{y}.png?APITOKEN=${apiKey}`,
            {
                maxZoom: 22,
                minZoom: 15,
            }
        );

        const baseMaps = {
            "Satelitt": satelittLayer,
            "Kart": kartLayer
        };

        kartLayer.addTo(mapInstance);
        L.control.layers(baseMaps, null, {position: 'topright'}).addTo(mapInstance);
        L.control.zoom({zoomInTitle: 'Zoom inn', zoomOutTitle: 'Zoom ut', position: 'topright'}).addTo(mapInstance);

        // Create a flat array of all facets with their building references
        const allFacets = [];
        calculatorState.buildings.forEach(building => {
            if (!building.roofs || !building.roofs.length) return;
            const buildingId = building.ByggId || 'default';

            // Add all roofs for this building
            building.roofs.forEach((roof, roofIndex) => {
                if (roof.facetData) {
                    allFacets.push({
                        ...roof.facetData,
                        buildingId: buildingId,
                        buildingIndex: getBuildingIndexMap()[buildingId],
                        roofIndex: roofIndex,
                        isSelected: roof.selected !== false // Default to true if not specified
                    });
                }
            });
        });

        // Process each facet individually
        allFacets.forEach((facet, index) => {
            try {
                if (!facet.Geometri) return;

                const geom = JSON.parse(facet.Geometri);
                if (!geom || geom.type !== 'Polygon' || !Array.isArray(geom.coordinates) || !geom.coordinates[0]) {
                    return;
                }

                // Convert coordinates to Leaflet format [lat, lng]
                const latLngs = geom.coordinates[0].map(coord => [coord[1], coord[0]]);
                const facetId = `facet-${facet.buildingId}-${facet.roofIndex}`;

                // Create polygon with the actual roof shape
                const polygon = L.polygon(latLngs, getPolygonStyles(facet.buildingIndex));

                // Set initial style based on selection state
                const initialStyles = getPolygonStyles(facet.buildingIndex);
                initialStyles.fillOpacity = facet.isSelected ? 0.9 : 0.3;
                initialStyles.weight = facet.isSelected ? 2 : 1;
                polygon.setStyle(initialStyles);

                // Add click handler to toggle facet selection
                polygon.on('click', function () {
                    // Toggle selection for this facet
                    const newSelectedState = !facetMap[facetId].isSelected;
                    facetMap[facetId].isSelected = newSelectedState;

                    // Update polygon style
                    const styles = getPolygonStyles(facet.buildingIndex);
                    styles.fillOpacity = newSelectedState ? 0.9 : 0.3;
                    styles.weight = newSelectedState ? 2 : 1;
                    polygon.setStyle(styles);

                    if (newSelectedState) {
                        polygon.bringToFront();
                    }

                    //1 get index of calculatorState.buildings by facet.buildingId
                    const buildingIndex = calculatorState.buildings.findIndex(building => building.ByggId === facet.buildingId);
                    //2 get index of calculatorState.buildings[buildingIndex].roofs by facet.Id
                    const roofIndex = calculatorState.buildings[buildingIndex].roofs.findIndex(roof => roof.id === facet.Id);
                    //3 update calculatorState.buildings[buildingIndex].roofs[roofIndex].selected
                    calculatorState.buildings[buildingIndex].roofs[roofIndex].selected = newSelectedState;

                    // find index in calculatorState.selectedRoofFacets by facet.id
                    const selectedRoofFacetsIndex = calculatorState.selectedRoofFacets.findIndex(selectedRoofFacet => selectedRoofFacet.facetData.Id === facet.Id);
                    // based on new status add or remove from calculatorState.selectedRoofFacets
                    if (newSelectedState) {
                        calculatorState.selectedRoofFacets.push({
                            facetId: facet.Id,
                            facetData: facet,
                        });
                    } else {
                        calculatorState.selectedRoofFacets.splice(selectedRoofFacetsIndex, 1);
                    }

                    updateBuildingVisibility(facet.buildingId);
                    updateBuildingsArea(facet.buildingId);
                    //UpdateBuildingPrice(facet.buildingId);
                    UpdatePopupDetailsTotals(facet.buildingId);
                    SyncBuildingTotalPrice(facet.buildingId);
                });

                // Store reference to polygon for later use
                facetMap[facetId] = {
                    polygon: polygon,
                    isSelected: facet.isSelected,
                    buildingId: facet.buildingId,
                    buildingIndex: facet.buildingIndex
                };

                polygon.addTo(mapInstance);

            } catch (e) {
                console.error('Error creating roof polygon:', e);
            }
        });

        // Add building markers
        const buildingMarkers = {};
        allFacets.forEach(facet => {
            if (!buildingMarkers[facet.buildingId] && facet.Geometri) {
                try {
                    const geom = JSON.parse(facet.Geometri);
                    if (geom && geom.type === 'Polygon' && geom.coordinates?.[0]) {
                        const bounds = getBoundsFromCoordinates([geom.coordinates[0]]);
                        const center = [
                            (bounds[0][0] + bounds[1][0]) / 2,
                            (bounds[0][1] + bounds[1][1]) / 2
                        ];

                        if (!isNaN(center[0]) && !isNaN(center[1])) {
                            const building = outputJson.Buildings.find(b => {
                                const bid = b.id || b.ID;
                                return bid && bid.toString() === facet.buildingId.toString();
                            });

                            if (building) {
                                const marker = L.marker(center, {
                                    icon: L.divIcon({
                                        html: `
                                            <div style="position: relative;">
                                                <div style="background: white; border-radius: 0.5rem; border: 1px solid #e5e7eb; width: fit-content; height: 30px; min-width: 100px; padding: 1rem; display: flex; align-items: center; justify-content: center; position: relative; z-index: 2;">
                                                    <span style="font-weight: 600; font-size: 13px; color: #111827;">
                                                        ${building.BuildingLabel || 'Building'}
                                                    </span>
                                                </div>
                                            </div>
                                        `,
                                        className: 'building-marker',
                                        iconSize: [100, 30],
                                        iconAnchor: [45, 15]
                                    })
                                }).addTo(mapInstance);

                                buildingMarkers[facet.buildingId] = marker;
                            }
                        }
                    }
                } catch (e) {
                    console.error('Error creating building marker:', e);
                }
            }
        });

        // Fit map to show all facets
        const allBounds = [];
        Object.values(facetMap).forEach(facet => {
            if (facet && facet.polygon) {
                const bounds = facet.polygon.getBounds();
                allBounds.push([
                    [bounds.getSouthWest().lat, bounds.getSouthWest().lng],
                    [bounds.getNorthEast().lat, bounds.getNorthEast().lng]
                ]);
            }
        });

        if (allBounds.length > 0) {
            const bounds = allBounds.reduce((acc, b) => {
                return [
                    [Math.min(acc[0][0], b[0][0]), Math.min(acc[0][1], b[0][1])],
                    [Math.max(acc[1][0], b[1][0]), Math.max(acc[1][1], b[1][1])]
                ];
            }, allBounds[0]);

            mapInstance.fitBounds(bounds, {padding: [20, 20]});
        }
    }

    // Add CSS for labels
    if (!document.querySelector('#roof-label-styles')) {
        const style = document.createElement('style');
        style.id = 'roof-label-styles';
        style.textContent = `
            .roof-polygon-label {
                background: transparent !important;
                border: none !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                color: inherit !important;
                pointer-events: none !important;
            }
            .roof-polygon-label::before {
                display: none !important;
            }
        `;
        document.head.appendChild(style);
    }

    //initMap();

    function showGlobalLoader() {
        const loader = document.getElementById('wds-global-loader');
        if (loader) {
            loader.style.display = 'flex';
        }
    }

    //cta button
    let cta_btns = document.querySelectorAll('.main_cta_btn');
    if (cta_btns.length) {
        cta_btns.forEach(btn => {
            btn.addEventListener('click', function (e) {
                showGlobalLoader();
                updateJsonData();
                saveLead();
                sendToCRM();
            });
        });
    }
    //cta button
    //save button
    let save_btn = document.querySelector('.estimate-edit__updated-estimate .save_btn');
    if (save_btn) {
        save_btn.addEventListener('click', function (e) {
            showGlobalLoader();
            updateJsonData();
            saveLead(true);
        });
    }

    //save button
    function saveLead(is_redirect = false) {
        //console.log('outputJson for save', outputJson);
        //console.log('calculatorState for save', calculatorState);

        const formData = new FormData();
        formData.append('action', 'wds_update_roof_lead');
        formData.append('nonce', wdsCalculatorData.nonce);
        formData.append('leadJson', JSON.stringify(outputJson));
        formData.append('calculatorState', JSON.stringify(getSerializableCalculatorState(calculatorState)));
        // send data to server
        fetch(window.wdsCalculatorData.ajax_url, {
            method: 'POST',
            body: formData
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                console.log(response);
                if (response.success) {
                    //window.location.href = thankYouUrl;
                    console.log('Lead saved successfully');
                    if (is_redirect) {
                        //page refresh
                        //console.log('redirect');
                        //console.log(outputJson);
                        //window.location.href = window.location.reload();
                        window.location.reload();
                    }
                    //hideEditDetails();
                } else {
                    console.error('Error:', response.data);
                }
            }).catch(function (error) {
            console.error('Error:', error);
        });
    }

    function sendToCRM() {
        const thankYouUrl = document.querySelector('.estimate-edit__updated-estimate').getAttribute('data-thank-you-url');
        const formData = new FormData();
        //new outputJson
        let newoutputJson = buildNewOutputJson(outputJson, calculatorState, buildingsHeights);
        //console.log('newoutputJson',newoutputJson);
        formData.append('action', 'wds_cta_endpoint_ajax');
        formData.append('nonce', wdsCalculatorData.nonce);
        formData.append('data', JSON.stringify(newoutputJson));
        // send data to server
        fetch(window.wdsCalculatorData.ajax_url, {
            method: 'POST',
            body: formData
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                console.log(response);
                if (response.success) {
                    window.location.href = thankYouUrl;
                } else {
                    console.error('Error:', response.data);
                }
            }).catch(function (error) {
            console.error('Error:', error);
        });
    }

    function getSerializableCalculatorState(state) {
        const {mapUrl, ...serializableState} = state;

        return {
            ...serializableState,
            selectedRoofFacets: state.selectedRoofFacets
                ? state.selectedRoofFacets.map(f => ({
                    facetId: f.facetId,
                    facetData: f.facetData
                }))
                : []
        };
    }
});
